export default __webpack_public_path__ + "static/media/Portfolio1.bf72cd1d.png";